import React from 'react';
import { Head } from '@inertiajs/react';
import { useTrans } from '../../hooks/useTrans';

export default function TrackAndTraceNotFound({ message }) {
    const translate = useTrans();

    return (
        <div className="panel">
            <Head title={translate('Rit niet gevonden')} />

            <div className="row row--wide">
                <div className="col12">
                    <div className="panel__main panel__main--larger-gutter">
                        <h3>{translate('Rit niet gevonden')}</h3>

                        <p>{message}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
